import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ItemErrorComponent } from '../../components/item-form-error/item-form-error.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import UserRestServices from '../../services/user-rest.service';
import UserService from '../../services/user.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RoutingService from '../../services/routing.service';
import { PanelDirective } from '../../directives/panel.directive';

@Component({
	standalone: true,
	selector: 'promo',
	templateUrl: './promo.component.html',
	imports: [ CommonModule, PanelDirective, TranslatePipe, LoaderOverlayComponent, ItemErrorComponent, FormsModule ]
})
export default class PromoView implements OnInit {
	private session: Session = inject(Session);
	private userRestServices: UserRestServices = inject(UserRestServices);
	private userService: UserService = inject(UserService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('promo').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
		this.vm.userPromoCode = this.vm.user.referralCode;
		
		this.vm.handleFormSubmit = this.handleFormSubmit;
		this.vm.handleInputChange = this.handleInputChange;
	}
	
	handleInputChange() {
		this.vm.error = undefined;
	}
	
	handleFormSubmit(form: any) {
		this.vm.formSubmitted = true;
		this.vm.success = undefined;
		this.vm.error = undefined;
		
		if (form.invalid || this.vm.processing) {
			this.vm.invalid = true;
			return;
		}
		this.vm.invalid = false;
		this.vm.processing = true;
		
		this.userRestServices.applyDiscount({ code: this.vm.code }, 
			(response) => {
				this.vm.formSubmitted = false;
				this.vm.code = undefined;
				this.vm.success = this.angularFilterHelperService.translate('Promo.Success').replace('%s', response.amount || 5);
				this.userService.clearWalletCache();
				this.vm.processing = false;
			},
			(response) => {
				try {
					this.vm.error = response.error[0].message;
				} catch (e) { }
				this.vm.processing = false;
			}
		);
	}
	
}